import { useState } from 'react';
import { categories } from '@/mocks/siteData';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      setSelectedCategory('');
    }
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Browse Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto mb-8">
            Explore our complete collection of Vigorbuy Spreadsheet product categories. Each category contains curated product guides, QC tips and price comparisons.
          </p>

          <div className="relative max-w-[420px] mx-auto">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-50 border border-background-300 rounded-xl px-5 py-3.5 pr-12 text-sm font-medium text-foreground-700 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all cursor-pointer"
            >
              <option value="" disabled>
                — Select a Category —
              </option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200/60 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-secondary-100 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-secondary-600 group-hover:text-primary-600 text-lg md:text-xl transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 text-center leading-tight">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}